<template>
  <div class="container">
    <div class="content">
      <div class="header">
        <div class="img-wrap">
          <img :src="advancedCard" alt="">
        </div>
      </div>
      <!-- 选择购买时长 -->
      <div class="body">
        <section class="purchase-duration">
          <div class="title">选择购买时长</div>
          <div class="package-group">
            <div class="package-item" :class="[selectedDuration === 1 ? 'selected' : '']" @click="handleSelect(1)">
              <div class="row">
                <span class="left">1年</span>
                <span class="right">￥{{2388 | moneyFormatGroup}}</span>
              </div>
              <div class="row tip">
                <span class="left">另外赠送1个月</span>
                <span class="right">￥{{3980 | moneyFormatGroup}}</span>
              </div>
              <!-- 角标 -->
              <div class="superscript">
                <div class="rect"></div>
                <div class="desc">
                  <span class="myicon-tick-check"></span>
                </div>
              </div>
            </div>
            <div class="package-item" :class="[selectedDuration === 2 ? 'selected' : '']" @click="handleSelect(2)">
              <div class="row">
                <span class="left">2年</span>
                <span class="right">￥{{4776 | moneyFormatGroup}}</span>
              </div>
              <div class="row tip">
                <span class="left">另外赠送2个月</span>
                <span class="right">￥{{7960 | moneyFormatGroup}}</span>
              </div>
              <!-- 角标 -->
              <div class="superscript">
                <div class="rect"></div>
                <div class="desc">
                  <span class="myicon-tick-check"></span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="content">
      <!-- 确认订单信息 -->
      <div class="body">
        <section class="order">
          <div class="title">确认订单信息</div>
          <div class="order-info">
            <p class="order-type">小麦助教标准版</p>
            <p class="order-duration">购买时长：1年（另赠送1个月）</p>
            <p class="expire-date">有效期：<span class="date">2018/07/09-2019/07/10</span></p>
          </div>
        </section>
      </div>
    </div>
    <!-- 购买须知 -->
    <div class="instruction-link">购买须知</div>
    <!-- 去结算 -->
    <div class="settlement">
      <div class="btn-settlement">去结算</div>
      <div class="account">
        <div class="amount">合计金额  <span class="price">￥{{2388 | moneyFormatGroup(2)}}</span></div>
        <div class="discount-amount">已优惠  ￥{{1592 | moneyFormatGroup(2)}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import standardCard from "@/images/renew/standard-card.png";
import advancedCard from '@/images/renew/advanced-card.png';

export default {
  data() {
    return {
      standardCard,
      advancedCard,
      selectedDuration: 2
    };
  },
  methods: {
    handleSelect(duration) {
      this.selectedDuration = duration;
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  background-color: #fff;
}
.header {
  padding: 0.3rem 0.5rem 0.05rem;
  line-height: 0;
  .img-wrap {
    display: inline-block;
    line-height: 0;
    width: 6.3rem;
    height: 3.24rem;
    img {
      width: 100%;
    }
  }
}
.body {
  section {
    padding: 0.2rem 0.3rem 0.3rem;
    .title {
      text-align: left;
      color: #333333;
      font-size: 0.34rem;
      font-weight: bold;
    }
    .package-group {
      margin-top: 0.2rem;
      .package-item {
        position: relative;
        padding: 0.2rem 0.4rem 0.2rem 0.3rem;
        border: 0.02rem solid #eee;
        &.selected {
          border-color: #ff8534;
          .superscript {
            bottom: 0px;
            right: 0px;
            width: 0.7rem;
            height: 0.7rem;
            overflow: hidden;
            .rect {
              width: 0.6rem;
              height: 0.6rem;
              margin: 0.4rem 0 0 0.4rem;
              background: #ff8534;
              transform: rotateZ(-45deg);
            }
            .desc {
              position: absolute;
              bottom: -20%;
              right: -8%;
              z-index: 10;
            }
          }
        }
        .row{
          color: #333;
          font-weight: 480;
          overflow: hidden;
          &.tip{
            font-size: 0.2rem;
            font-weight: 400;
            color: #999;
            .left,
            .right{
              font-size: 0.26rem;
            }
            .right{
              text-decoration: line-through;
            }
          }
          .left{
            float: left;
            font-size: 0.34rem;
          }
          .right{
            float: right;
            font-size: 0.34rem;
          }
        }
      }
      .package-item:first-child {
        border-bottom: 0 none;
        border-radius: 0.1rem 0.1rem 0 0;
      }
      .package-item:last-child {
        border-radius: 0 0 0.1rem 0.1rem;
        border-top-color: #ff8534;
      }
    }
    .order-info {
      margin-top: 0.3rem;
      text-align: left;
      p{
        font-size: 0.26rem;
        line-height: 0.48rem;
        .date{
          color: #ff8534;
          font-size: 0.26rem;
        }
      }
    }
  }
}
.superscript {
  position: absolute;
}
.myicon-tick-check {
  display: inline-block;
  position: relative;
  width: 0.3rem;
  height: 0.3rem;
  border-radius: 50%;
}

.myicon-tick-check::before {
  content: "";
  position: absolute;
  width: 0.08rem;
  height: 0.16rem;
  color: black;
  border-bottom: 1px solid #fff;
  border-right: 1px solid #fff;
  left: 40%;
  top: 40%;
  transform-origin: center;
  transform: translate(-50%, -30%) rotate(45deg);
  -webkit-transform: translate(-50%, -30%) rotate(45deg);
}
.instruction-link {
  font-size: 0.26rem;
  color: #999;
}
.settlement{
  position: fixed;
  width: 100%;
  text-align: left;
  bottom: 0;
  left: 0;
  background-color: #fff;
  .account{
    padding: 0.14rem 0.32rem;
    height: 1.15rem;
    .amount{
      font-size: 0.3rem;
      font-weight: 500;
      .price{
        color:#ff8534;
      }
    }
    .discount-amount{
      font-size: 0.2rem;
      color: #999;
    }
  }
  .btn-settlement{
    float: right;
    width: 2.4rem;
    height: 1.15rem;
    text-align: center;
    line-height: 1.15rem;
    color: #fff;
    font-size: 0.3rem;
    background: -webkit-linear-gradient(left, #FFAB1A , #ff8534); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(right, #FFAB1A, #ff8534); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(right, #FFAB1A, #ff8534); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, #FFAB1A , #ff8534); /* 标准的语法 */
  }
}
</style>




// WEBPACK FOOTER //
// src/module/renew/purchase.vue